<template>
    <div class="app-container">
        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">NQI服务</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/zltszhfw/zlypp' }">质量及品牌</el-breadcrumb-item>
                    <el-breadcrumb-item>详情</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>

        <el-row class="content">
            <h1  style="font-family: 微软雅黑, 宋体">{{detail.title}}</h1>
            <el-row class="soure">
                <span style="padding-right: 15px;">发布时间：{{ parseTime(detail.fbTime, '{y}-{m}-{d}') }}</span><span style="padding-right: 15px;">访问量：{{browseCount}}</span><span>来源：{{fbDept}}</span>
            </el-row>
            <div v-html="detail.content" class="eidt-content"></div>
<!--            <div style="align-content: center" align="center"><img src="../../../../assets/images/file_tmp/pinpaishenbaotongzhi.png" style="width: 1000px"></img></div>-->
        </el-row>

    </div>
</template>

<script>
    import { getBrowseCount } from "@/api/basedata/records";
    import {getTzgg} from "@/api/zlts/zlppfw/tzgg";
    export default {
        name: "detail",
        data() {
            return {
                // 遮罩层
                loading: true,
                recid:undefined,
                type:undefined,
                detail:{},
                ywViews:{
                    busRecid:undefined,
                    busTableName:'yw_zlts_zlppfw_tzgg',
                },
                browseCount:undefined,
                fbDept: '威海市市场监督管理局',
            }
        },
        created() {
            this.recid = this.$route.params && this.$route.params.recid;
            this.getDetail();
        },
        methods: {
            toPage(url){
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            refresh(){
                this.getDetail();
            },
            getDetail(){
                let recid = this.recid;
                getTzgg(recid).then(response => {
                    this.detail = response.data;
                    this.getBrowseData();
                });
                /*
                this.detail={
                    title:'市场监管总局办公厅关于开展第四届中国质量奖评选表彰工作的通知',
                    updateTime:'2021-10-13 10:17',
                    deptname:'威海市市场监督管理局',
                    content:'<p>ICS 03.120.01</p><p>&nbsp;CCS A12<br/></p><h1 style="text-align:left;" id="6rzkm">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; DB3710<br/></h1><p data-we-empty-p="" style="text-align:justify;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font size="6">威 海 市 地 方&nbsp;标&nbsp;准</font></p><p data-we-empty-p="" style="text-align:justify;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; DB 3710/T 134—2<font size="6"><br/></font></p><hr/><p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 同线同标同质企业建设指南<br/></p><p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Guide to the construction of enterprises with the same line, the same standard and the\n' +
                        'same quality<br/></p><p><br/></p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;前 言<br/></p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本文件按GB/T 1.1-2020《标准化工作导则 第1部分：标准化文件的结构和起草规则》给出的规则\n' +
                        '起草。&nbsp;</p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本文件由威海市市场监督管理局提出、归口并组织实施和评价。&nbsp;</p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本文件起草单位：威海市市场监督管理局、威海市产品质量标准计量检验研究院。</p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本文件主要起草人：鲁晓成、苏海涛、王淑梅、于春凤、徐海静、邵志莲、林宇春。<br/></p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;引<span style="font-size: 14px;">&nbsp;言</span>&nbsp;</p><p><br/></p><p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 2014年9月，李克强总理在视察质检工作时提出，要积极促进出口企业内外销产品在同一生产线、\n' +
                        '按相同的标准生产，达到相同的质量水平。2020年6月，国务院办公厅印发《关于支持出口产品转内销\n' +
                        '的实施意见》中，提出促进“同线同标同质”（以下简称“三同”）发展，扩大“三同”适用范围至一\n' +
                        '般消费品、工业品领域，进一步促进优质产品及服务供给，打造质量标杆。为了促进威海企业转型升级，\n' +
                        '扩大国内市场份额和品牌影响力，进一步实现经济效益和社会效益双赢，在全国质量提升和经济转型中\n' +
                        '起到表率和导向作用，特制订本文件。</p><p><br/></p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;同线同标同质企业建设指南<br/></p><p><br/></p><p>1 范围</p><p>&nbsp;本文件规定了同线同标同质企业建设的基本条件、“三同”企业建设指标。</p><p>&nbsp;本文件适用于参与同线同标同质建设工作的企业。&nbsp;</p><p>2 规范性引用文件&nbsp;</p><p>下列文件中的内容通过文中的规范性引用而构成本文件必不可少的条款。其中，注日期的引用文件，\n' +
                        '仅该日期对应的版本适用于本文件；不注日期的引用文件，其最新版本（包括所有的修改单）适用于本\n' +
                        '文件。&nbsp;</p><p>RB/T 155 同线同标同质 检验检疫机构监管指南&nbsp;</p><p>3 术语和定义</p><p>&nbsp;RB/T 155界定的以及下列术语和定义适用于本文件。</p><p>&nbsp;3.1&nbsp;</p><p>“同线同标同质”企业（“三同”企业） Same line Same standard Same quality enterprise&nbsp;</p><p>符合“同线同标同质”要求，具有一定的规模优势，创新能力强，执行标准严，品牌效应大，社会\n' +
                        '信誉好，在总产值、出口贸易额、科研投入、服务产业发展等方面起到领先和带动作用的生产企业</p><p><br/></p><p><br/></p><p><br/></p>'

                };
                */
                //this.getBrowseData();
            },
            getBrowseData(){
                this.ywViews.busRecid= this.recid;
                getBrowseCount(this.ywViews).then(response => {
                    this.browseCount=response;
                })
            }
        }
    }
</script>

<style scoped>
    .app-container{
        padding:0px 15px 20px;
        background-color: #ffffff;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
    .content{
        border: 1px solid #cccccc;
        padding:20px 80px;
    }
    .soure{
        background-color:#f3f3f3;
        padding:10px;
        margin: 25px 0;
    }
</style>